import { NOTE_CODE_FOR_CANCEL_APPOINTMENT } from 'constants/note';

export default (values) => Object
  .values(NOTE_CODE_FOR_CANCEL_APPOINTMENT)
  .includes(values.primaryDisease.code);
